import { render } from "./SkinManagemente.vue?vue&type=template&id=6885809e&scoped=true&ts=true"
import script from "./SkinManagemente.vue?vue&type=script&lang=ts"
export * from "./SkinManagemente.vue?vue&type=script&lang=ts"

import "./SkinManagemente.vue?vue&type=style&index=0&id=6885809e&scoped=true&lang=css"
import "./SkinManagemente.vue?vue&type=style&index=1&id=6885809e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6885809e"]])

export default __exports__